import {Component, Input, OnInit} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {
  monthlyRevenueExpectationValues,
  averageTicketValues,
} from '@gatewee/types/onboarding';

@Component({
  selector: 'app-estimated-volumes-form',
  templateUrl: './estimated-volumes-form.component.html',
  styleUrls: ['./estimated-volumes-form.component.css'],
  standalone: false,
})
export class EstimatedVolumesFormComponent implements OnInit {
  @Input() formGroup!: FormGroup;

  monthlyRevenueOptions = monthlyRevenueExpectationValues.map(item => ({
    value: item.value,
    label: item.name,
  }));

  averageTicketOptions = averageTicketValues.map(item => ({
    value: item.value,
    label: item.name,
  }));

  ngOnInit(): void {
    this.formGroup.get('noWebsite')?.valueChanges.subscribe(noWebsite => {
      if (noWebsite) {
        this.formGroup.get('website')?.reset();
      }
    });
  }
}
